import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/cart-context/cart-context';
import { useEffect } from 'react';

export const  CheckParams = ({children}) => {
    const { cartId } = useCart();
    const { order } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!order) {
            navigate('/');
        }
    }, [order, cartId, navigate]);

    return children
}